
import { Component, OnInit, ViewChild  } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ListalicenciasService } from '../../services/solicitante/listalicencias.service';
import { Licencia } from '../../models/licencia';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Solicitante } from '../../models/solictante';
import { PescadoresComponent } from '../pescadores/pescadores.component';







@Component({
  selector: 'app-gestores',
  templateUrl: './gestores.component.html',
  styleUrls: ['./gestores.component.css']
})
export class GestoresComponent implements OnInit {

  nombre = '';
  email = '';
  telefono = '';
  prioridad = 0 ;
  idusuario = '';
  limpiaListadosPescador: boolean;

  btonpresionado: boolean;

  isDivVisible: boolean;


  @ViewChild(PescadoresComponent, {static: true}) pescadores: PescadoresComponent;

  constructor(
    private solicitanteService: SolicitanteService,
    private loginUsuario: UsuarioService,
  ) {
   }

  ngOnInit() {
    localStorage.setItem('pagina', 'gestor');
    // this.nombre = this.loginUsuario.usuarioLogin.nombreempresa;
    this.email = this.loginUsuario.emailempresa;
   // this.telefono = this.loginUsuario.usuarioLogin.telefono;
    this.idusuario = this.loginUsuario.usuarioLogin._id;
   // this.prioridad = this.loginUsuario.usuarioLogin.prioridad;

    this.isDivVisible = false;
    this.btonpresionado = false; // este controla el boton de nueva solkicitud se deshabilita o habilita






  }





  registrarSolicitante() {

    this.limpiaListadosPescador = true;
    this.btonpresionado = true;
    const solicitante = new Solicitante(
      this.nombre,
      this.email,
      this.telefono,
      this.idusuario,
    //  this.prioridad
    );

    this.crearSolicitantes (solicitante);

    // this.limpiaSolicitantes();
    this.inicializacaptura();

    }

    // limpiaSolicitantes(){

    // }


    crearSolicitantes( solicitante: Solicitante) {
      this.solicitanteService.crearSolicitante( solicitante )
    .subscribe ( resp => {
      console.log ('solicitante creado');
      this.isDivVisible = true;
    });
    }


    recibirrespuesta(accion: boolean) {

      this.btonpresionado = accion ;
      console.log ( accion);
    }


    inicializacaptura() {
    this.pescadores.Inicializadesplieguetablas();
    }


}

